import { toCamelCaseProperties } from '@/utils/fn';

export default class Employee {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.description = args.description || '';
		this.employeeId = args.employeeId || '';
		this.firstName = args.firstName || '';
		this.imageUrlLarge = args.imageUrlLarge || '';
		this.imageUrlMedium = args.imageUrlMedium || '';
		this.imageUrlSmall = args.imageUrlSmall || '';
		this.imageVersion = args.imageVersion || 0;
		this.imgUrl = args.imgUrl || '';
		this.lastName = args.lastName || '';
		this.siteId = args.siteId || 0;
		this.sortNo = args.sortNo || 0;
		this.title = args.title || '';
		this.treatments = args.treatments || [];
		this.treatmentsWithPrice = args.treatmentsWithPrice || []; // @TODO: In future: When `treatmentsWithPrice` is used, should be mapped to its own class.
		this.webId = args.webId || '';
	}
}
